import { ChangeEvent, FocusEvent, useMemo } from "react";
import { FormikErrors } from 'formik';
import { AttributeTypeField } from "@idw-types/data";
import { AttributeFormState } from "@idw-types/state/attribute-form-state";
import { AXNUITextInputWithErrorMessage } from '@iddataweb/idw-common-ui/containers';
import { Logger } from "@utils/logger";
import { AXNUIContentCustomAttributeField } from "@iddataweb/idw-common-ui/types";

type CustomTextFieldProps = {
    attributeFieldContent: AXNUIContentCustomAttributeField;
    attribute: AttributeFormState;
    attributeTypeField: AttributeTypeField;
    fieldError: string;
    fieldTouched: boolean;
    fieldIsInvalid: boolean;
    fieldShouldBeHighlighted: boolean;
    isSubmitting: boolean;
    type: "number" | "text";
    onBlur: (event: FocusEvent<HTMLInputElement>) => void;
    setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void;
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void> | Promise<FormikErrors<any>>;
    onSetSubmitValue: (data: { inputData: { [key: string]: string } }) => void;
};

export const CustomTextField = (props: CustomTextFieldProps) => {
    const {
        attributeFieldContent,
        attribute,
        attributeTypeField,
        fieldError,
        fieldTouched,
        fieldIsInvalid,
        fieldShouldBeHighlighted,
        isSubmitting,
        type,
        onBlur,
        setFieldTouched,
        setFieldValue,
        onSetSubmitValue
    } = props;

    const handleChange = async (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        Logger.info("[CustomNumericField] submit value: ", value);
        const inputData = { ...attribute.inputData, [attributeTypeField.name]: value };
        onSetSubmitValue({ inputData });
        await setFieldValue(attributeTypeField.name, value);
        setFieldTouched(attributeTypeField.name, true, true);
    };

    const value = useMemo(() => {
        if (attribute.isPlaceholder && attribute.prefillValueMap[attributeTypeField.name]) {
            return attribute.prefillValueMap[attributeTypeField.name] || "";
        } else {
            return attribute.inputData[attributeTypeField.name];
        }
    }, [attribute.inputData, attribute.prefillValueMap, attribute.isPlaceholder]);

    return (
        <div>
            <AXNUITextInputWithErrorMessage
                controlId={`attr${attribute.id}-inputs-${attributeTypeField.name}`}
                automationId={`attr${attribute.id}-inputs-${attributeTypeField.name}`}
                autocomplete={"new-password"}
                fieldName={attributeTypeField.name}
                fieldError={fieldError}
                fieldTouched={fieldTouched}
                fieldIsInvalid={fieldIsInvalid}
                fieldShouldBeHighlighted={fieldShouldBeHighlighted}
                type={type}
                onBlur={onBlur}
                setFieldTouched={setFieldTouched}
                isDisabled={attribute.isDisabled}
                isPlaceholder={attribute.isPlaceholder}
                isOptional={attribute.optional}
                isSubmitting={isSubmitting}
                onChange={handleChange}
                title={attributeFieldContent.label}
                placeholder={attributeFieldContent.placeholder}
                value={value}
            />
        </div>
    );
};